import * as React from 'react';
import {DragDropContext} from 'react-beautiful-dnd';

import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {ClosedLeadMailChimpSubscriptionContainer} from '../card-containers/closed-lead-mailchimp-subscription-container';

import {CollapsibleSection} from './collapsible-section';

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
};

export function ClosedLeadMailChimpSubscriptions(props: Props) {
    return (
        <DragDropContext onDragEnd={() => {}}>
            <CollapsibleSection type='closedLeadMailChimpSubscriptions'>
                {['LEAD_WON', 'LEAD_LOST', 'LEAD_CANCELLED'].map((outcomeType) => (
                    <ClosedLeadMailChimpSubscriptionContainer
                        key={outcomeType}
                        // @ts-expect-error
                        outcomeType={outcomeType}
                        isLoading={props.isLoading}
                        errorMessage={props.errorMessage}
                        closedLeadAutomations={props.closedLeadAutomations}
                    />
                ))}
            </CollapsibleSection>
        </DragDropContext>
    );
}
